angular.module("ainapp")
    .controller("JobWiseProfitDetailsController", ["$scope", "app.config", "$http", "$state", "AuthenticationService", "MainService",
        function ($scope, config, $http, $state, AuthenticationService, MainService) {


            $scope.PageName = "Job Wise Profit Details";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.CostCentersList = [];
            MainService.GetAllCostcentersInJobReprot().then(function (response) {
                $scope.CostCentersList = response.data;
            });


            $scope.Init = function () {

                $scope.isLoadReport = false;
                $scope.ViewVal = 0;

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    Level: 0,
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                }

                $scope.finyear = {};
                MainService.getCurrentFinancialYear().then(function (response) {
                    $scope.finyear = response.data;
                    $scope.filter.FromDate = new Date($scope.finyear.StartDate);
                });

                $scope.CostCenters = [];
                MainService.GetJobCostCenters().then(function (response) {
                    $scope.CostCenters = response.data;
                });

                $('#filterModal').modal('show');

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isLoadReport) {

                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.JobNos = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                if (e.IsSelected) {
                                    o.data.JobNos.push(e.Name);
                                }
                            })

                            o.data.CostCenterList = [];
                            angular.forEach($scope.CostCentersList, function (e) {
                                if (e.SelectedCostCenterId > 0) {
                                    o.data.CostCenterList.push(e.SelectedCostCenterId);
                                }
                            })

                            MainService.JobWiseProfitDetails(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            JobNo: {
                                type: "string",
                                editable: false
                            },
                            VoucherNo: {
                                type: "string",
                                editable: false
                            },
                            VoucherType: {
                                type: "string",
                                editable: false
                            },
                            Date: {
                                type: "date",
                                editable: false
                            },
                            "AccountName": {
                                type: "string",
                                editable: false
                            },
                            SINVGross: {
                                type: "number",
                                editable: false
                            },
                            PINVGross: {
                                type: "number",
                                editable: false
                            },
                            PINVFreightCharges: {
                                type: "number",
                                editable: false
                            },
                            PINVPackingCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVClearingCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVDutyCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVFreightharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVOtherharges: {
                                type: "number",
                                editable: false
                            },
                            ReceiptCommission: {
                                type: "number",
                                editable: false
                            },
                            ExpenseAmount: {
                                type: "number",
                                editable: false
                            },
                            ProfitLossValue: {
                                type: "number",
                                editable: false
                            },
                            StockIssueCharges: {
                                type: "number",
                                editable: false
                            },

                        }
                    }
                },
                group: [{
                    field: "JobNo",
                    aggregates: [
                        {
                            field: "SINVGross",
                            aggregate: "sum"
                                },
                        {
                            field: "PINVGross",
                            aggregate: "sum"
                                },
                        {
                            field: "PINVFreightCharges",
                            aggregate: "sum"
                                },
                        {
                            field: "PINVPackingCharges",
                            aggregate: "sum"
                                },
                        {
                            field: "IPINVClearingCharges",
                            aggregate: "sum"
                                },
                        {
                            field: "IPINVDutyCharges",
                            aggregate: "sum"
                                },
                        {
                            field: "IPINVFreightharges",
                            aggregate: "sum"
                                },
                        {
                            field: "IPINVOtherharges",
                            aggregate: "sum"
                                },
                        {
                            field: "ReceiptCommission",
                            aggregate: "sum"
                                },
                        {
                            field: "ExpenseAmount",
                            aggregate: "sum"
                                },
                        {
                            field: "ProfitLossValue",
                            aggregate: "sum"
                                }, {
                            field: "StockIssueCharges",
                            aggregate: "sum"
                                }
                        ]
                    }],
                aggregate: [
                    {
                        field: "SINVGross",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVGross",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVFreightCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVPackingCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVClearingCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVDutyCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVFreightharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVOtherharges",
                        aggregate: "sum"
                                },
                    {
                        field: "ReceiptCommission",
                        aggregate: "sum"
                                },
                    {
                        field: "ExpenseAmount",
                        aggregate: "sum"
                                },
                    {
                        field: "ProfitLossValue",
                        aggregate: "sum"
                                }, {
                        field: "StockIssueCharges",
                        aggregate: "sum"
                                }
                            ],
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                dataBound: onDataBound,
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                selectable: true,

                columns: [
                    {
                        field: "JobNo",
                        title: "Job No",
                        hidden: true,
                        width: "100px"
                            },
                    {
                        field: "VoucherNo",
                        title: "Voucher No",
                        width: "100px"
                            },
                    {
                        field: "VoucherType",
                        title: "Voucher Type",
                        width: "100px"
                            },
                    {
                        field: "AccountName",
                        title: "Customer",
                        width: "100px"
                            },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "100px"
                            },
                    {
                        field: "SINVGross",
                        title: "Sales Invoice Gross",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(SINVGross, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "PINVGross",
                        title: "Purchase Invoice Gross",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(PINVGross, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "PINVFreightCharges",
                        title: "Freight Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(PINVFreightCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "PINVPackingCharges",
                        title: "Packing Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(PINVPackingCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "IPINVClearingCharges",
                        title: "Import Clearing Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVClearingCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "IPINVDutyCharges",
                        title: "Import Duty Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVDutyCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "IPINVFreightharges",
                        title: "Import Freight Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVFreightharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "IPINVOtherharges",
                        title: "Import Other Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVOtherharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "ReceiptCommission",
                        title: "Receipt Commission Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(ReceiptCommission, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "StockIssueCharges",
                        title: "Stock Issue Charges",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(StockIssueCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "ExpenseAmount",
                        title: "Expenses",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(ExpenseAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "ProfitLossValue",
                        title: "Profit / Loss",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(ProfitLossValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px"
                            },
                    {
                        field: "",
                        width: "200px",
                        title: "Cost Centers",
                        template: "<span ng-repeat='jp in dataItem.JobwiseProfitCosts'>{{jp.CostCenterName}} * </span>"
                            },
                    ],
            };

            function onDataBound() {
                var grid = this;
                grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                    grid = $("#Kendo-Grid").data("kendoGrid");
                    var selectedData = grid.dataItem(grid.select());
                    $scope.goLegerVoucher(selectedData);
                })
            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isLoadReport = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                $('#filterModal').modal('hide');
            }



            $scope.goLegerVoucher = function (selectedData) {

                console.log(selectedData)

                if (selectedData.VoucherType == "Sales Invoice") {
                    $state.go("editSalesInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Sales Return") {
                    $state.go("editSalesReturn", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Purchase Invoice") {
                    $state.go("editPurchasVoucherTypeeInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Purchase Return") {
                    $state.go("editPurchaseReturn", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Opening Balance") {
                    $state.go("editOpeningBalance", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Fund Payment Voucher") {
                    $state.go("editFPVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Fund Receipt Voucher") {
                    $state.go("editFRVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Cash Payment Voucher") {
                    $state.go("editCPVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Cash Receipt Voucher") {
                    $state.go("editCRVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Cheque Payment Voucher") {
                    $state.go("editChequePVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Cheque Receipt Voucher") {
                    $state.go("editChequeRVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Journal Voucher") {
                    $state.go("editJVMaster", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "PDC") {
                    //                $state.go("editPurchaseInvoice", {
                    //                    VoucherId: selectedData.VoucherId
                    //                })
                } else if (selectedData.VoucherType == "Company Expense") {
                    $state.go("editcompanyExpense", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Counter Sales") {
                    //                $state.go("editPurchaseInvoice", {
                    //                    VoucherId: selectedData.VoucherId
                    //                })
                }
                //            if (selectedData.VoucherType == "Contract Invoice") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.VoucherId
                //                })
                //            }
                else if (selectedData.VoucherType == "Direct Sales Invoice") {
                    $state.go("editDirSalesInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Direct Purchase Invoice") {
                    $state.go("editDirPurchaseInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Export Sales Invoice") {
                    $state.go("editExpSalesInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Export Purchase Invoice") {
                    $state.go("editExpPurchaseInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Import Purchase Invoice") {
                    $state.go("editImpPurchaseInvoice", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Opening Stock") {
                    $state.go("editOpeningStock", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Stock Issue") {
                    $state.go("editStockIssue", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Stock FOC") {
                    $state.go("editStockFOC", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Stock Receive") {
                    $state.go("editStockRecieve", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Credit Note") {
                    $state.go("editCreditNote", {
                        VoucherId: selectedData.VoucherId
                    })
                } else if (selectedData.VoucherType == "Debit Note") {
                    $state.go("editDebitNote", {
                        VoucherId: selectedData.VoucherId
                    })
                }
            }



        }]);
